
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { UseFormReturn } from "react-hook-form";

interface InstructionsTabProps {
  form: UseFormReturn<any>;
}

const InstructionsTab = ({ form }: InstructionsTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Instructions & Restrictions</CardTitle>
        <CardDescription>
          Define how your agent should respond and what it should avoid.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <FormField
          control={form.control}
          name="instructions"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Instructions</FormLabel>
              <FormControl>
                <Textarea 
                  placeholder="Specific instructions for how the agent should respond"
                  className="min-h-[160px]"
                  {...field}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="restrictions"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Restrictions</FormLabel>
              <FormControl>
                <Textarea 
                  placeholder="Topics or information the agent should avoid discussing"
                  className="min-h-32"
                  {...field}
                  value={field.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
};

export default InstructionsTab;
